import type { ShowResultsReleasePayloadOutput } from '@schemas'
import { parseDateOnlyToLocal } from '@/lib/date'

// Shared by the public page and the staff review, so the review shows what the page will.
type Results = ShowResultsReleasePayloadOutput
const BLACK_JAR_MODEL_KEY = 'h-black-jar'

export function showDates(show: Pick<Results['show'], 'startDate' | 'endDate'>) {
  const format = (value: string) =>
    parseDateOnlyToLocal(value)?.toLocaleDateString(undefined, { dateStyle: 'long' }) ?? value
  return show.startDate === show.endDate
    ? format(show.startDate)
    : `${format(show.startDate)} – ${format(show.endDate)}`
}

/** The Black Jar winner is first place in the class linked to that model. */
export function blackJarWinners(results: Results) {
  return results.divisions
    .flatMap(division => division.classes.map(cls => ({ division, cls })))
    .filter(({ cls }) => cls.modelClassKey === BLACK_JAR_MODEL_KEY)
    .flatMap(({ division, cls }) =>
      cls.placements
        .filter(placement => placement.place === '1st')
        .map(placement => ({
          exhibitId: placement.exhibitId,
          entrant: placement.entrant,
          club: placement.club,
          entryTitle: placement.entryTitle,
          class: { code: cls.code, name: cls.name },
          division: { code: division.code, name: division.name },
        }))
    )
}
